import { formatCurrency } from '../../util/helpers/numberHelpers.ts';
import { stringIsNullOrEmpty } from '../../util/helpers/stringHelpers.ts';
import { FrontierRoomTypeViewModel } from '../../globalModels/hotels/frontier/frontierRoomTypes.ts';
import { ActivityInformationHotelModel } from '../../features/activities/informationDisplays/api/useActivityInformationHotelQuery.ts';

export default function HotelRatesText({
  hotel,
  length = 0,
  noSpace
}: {
  hotel: ActivityInformationHotelModel;
  length?: number;
  noSpace?: boolean;
}) {
  let sortedRoomRates = hotel.RoomTypes.filter((x) => x.Active)
    .slice()
    .sort((a, b) => a.ActiveRate?.SingleRate - b.ActiveRate?.SingleRate);
  sortedRoomRates = sortedRoomRates.slice(0, length <= 0 ? sortedRoomRates.length : length);
  return (
    <>
      {sortedRoomRates.map((x) => {
        if (x.ActiveRate == null) {
          return <></>;
        }
        const campRateString = BuildCampRateString(hotel, x);
        return (
          <div key={`${x.Id}_${x.RoomType}`}>
            <div style={{ color: '#007bff', fontWeight: 'bold' }}>
              {!noSpace && <> &nbsp;</>}
              {x.RoomType} Single: {formatCurrency(x.ActiveRate?.SingleRate)}
              {/* If double rate is different than single, render different font */}
              {x.ActiveRate.DoubleRate != null && x.ActiveRate.DoubleRate! > 0 && (
                <span style={{ color: '#007bff', fontWeight: 'normal' }}>
                  , Double: &nbsp;
                  {formatCurrency(x.ActiveRate.DoubleRate)}
                </span>
              )}
              {!stringIsNullOrEmpty(campRateString) && <span>, {campRateString}</span>}
            </div>
          </div>
        );
      })}
    </>
  );
}

function BuildCampRateString(hotel: ActivityInformationHotelModel, hotelRoomType: FrontierRoomTypeViewModel) {
  if (!hotel.IsCamp) {
    return null;
  }
  const toReturn = new Array<string>();
  if (hotelRoomType.ActiveRate.CampSurcharge != null) {
    toReturn.push(`Fee: ${formatCurrency(hotelRoomType.ActiveRate.CampSurcharge)}`);
  }
  if (!stringIsNullOrEmpty(hotelRoomType.ActiveRate.CampNote)) {
    toReturn.push(`Fee Note: ${hotelRoomType.ActiveRate.CampNote}`);
  }
  return toReturn.join(', ');
}
